import { css, keyframes } from '@emotion/react';
import * as React from 'react';

const rotateAnimation = keyframes`
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
`;

interface Props {
  size?: Size;
  circleColor?: string;
  spinnerColor?: string;
}

type Size = 'small' | 'medium' | 'large';

const sizes: { [key in Size]: number } = {
  small: 24,
  medium: 30,
  large: 48,
};

export const Spinner: React.FC<Props> = ({
  size = 'large',
  circleColor = '#E6E6E6',
  spinnerColor = '#1A1A1A',
}) => (
  <svg
    data-test="spinner"
    css={css`
      animation: ${rotateAnimation} 800ms 0ms linear reverse infinite;
    `}
    width={sizes[size]}
    height={sizes[size]}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM3.12 24C3.12 35.5317 12.4683 44.88 24 44.88C35.5317 44.88 44.88 35.5317 44.88 24C44.88 12.4683 35.5317 3.12 24 3.12C12.4683 3.12 3.12 12.4683 3.12 24Z"
      fill={circleColor}
    />
    <path
      d="M48 24C48 27.1517 47.3792 30.2726 46.1731 33.1844C44.967 36.0962 43.1992 38.742 40.9706 40.9706C38.742 43.1992 36.0962 44.967 33.1844 46.1731C30.2726 47.3792 27.1517 48 24 48L24 44.88C26.742 44.88 29.4572 44.3399 31.9904 43.2906C34.5237 42.2413 36.8255 40.7033 38.7644 38.7644C40.7033 36.8255 42.2413 34.5237 43.2906 31.9904C44.3399 29.4572 44.88 26.742 44.88 24H48Z"
      fill={spinnerColor}
    />
  </svg>
);
